import { POICONTENT } from "../../actions/portal/";

export default function(state = null, action) {
  switch (action.type) {
    case POICONTENT:
      return action.payload;
    default:
  }

  return state;
}
